<div class="welcome-section">
    <h1 class="welcome-title">Bienvenido a Safe & Confidence</h1>
    <p class="welcome-subtitle">Liderando el transporte ejecutivo y la seguridad personalizada con más de 15 años de experiencia.</p>
    <a href="" class="btn btn-primary">Descubre nuestros servicios</a>

    <div class="features container mt-5" id="features">
        <div class="row">
            <div class="col-md-4 feature-item">
                <div class="feature-icon">🚘</div>
                <h3>Transportación Ejecutiva</h3>
                <p>Viajes cómodos, seguros y puntuales con choferes certificados en manejo defensivo.</p>
            </div>
            <div class="col-md-4 feature-item">
                <div class="feature-icon">🛡️</div>
                <h3>Autos Blindados</h3>
                <p>Máxima protección para ti y tus acompañantes en cualquier destino.</p>
            </div>
            <div class="col-md-4 feature-item">
                <div class="feature-icon">✨</div>
                <h3>Eventos Especiales</h3>
                <p>Servicios premium para eventos exclusivos como Fórmula Uno y más.</p>
            </div>
        </div>
    </div>
</div>

